module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-reg"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "reg-modal-title"
  }, [_vm._v("ĐĂNG KÝ TÀI KHOẢN MỚI")]), _c('span', {
    staticClass: "reg-modal-btn-close material-icons",
    on: {
      "click": _vm.exitRegister
    }
  }, [_vm._v("close")])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "reg-content"
  }, [_vm._v("Bạn muốn đăng ký tài khoản với vai trò nào?")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-12 text-center reg-select-student"
  }, [_c('div', {
    staticClass: "border-box"
  }, [_c('div', {
    class: _vm.selectStudent ? 'item-type-selected' : 'item-unselect',
    on: {
      "click": function($event) {
        return _vm.itemSelect('student')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/register/img_student.svg")
    }
  }), _c('p', {
    staticClass: "reg-body-title"
  }, [_vm._v("Học sinh")])])])]), _c('div', {
    staticClass: "col-md-6 col-12 text-center reg-select-teacher"
  }, [_c('div', {
    staticClass: "border-box"
  }, [_c('div', {
    class: _vm.selectTeacher ? 'item-type-selected' : 'item-unselect',
    on: {
      "click": function($event) {
        return _vm.itemSelect('teacher')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/register/img_teacher.svg")
    }
  }), _c('p', {
    staticClass: "reg-body-title"
  }, [_vm._v("Giáo viên")])])])])])]), _c('div', {
    staticClass: "modal-footer reg-custom-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-6 col-12"
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "reg-btn-continue btn",
    on: {
      "click": function($event) {
        return _vm.validateRegister()
      }
    }
  }, [_vm._v("Tiếp tục")])])]), _c('div', {
    staticClass: "col-md-6 col-xs-6 col-12"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "reg-btn-back btn",
    on: {
      "click": _vm.exitRegister
    }
  }, [_vm._v("Quay lại")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-580a68ea","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/RegisterModal.vue
// module id = 1571
// module chunks = 0